import { FormControl, TextField } from '@mui/material';
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep, debounce, has, isEmpty } from 'lodash';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { getUpdatedData } from '../../../RightContextMenu/ContextActions/NewRecord';
import { getSelectedNodes } from '../../../RightContextMenu/ContextActions/CopyAndPaste';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { treeActions } from '../../../../redux/slices/treeSlice';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genericRules, validateOnFlow, validateRevertTime, validationTime } from '../../../../utils/validate';

const FixedLengthFieldProperty = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const timerID = useRef();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const templateHeader = rightTree.tree.templateHeader;
    const {translatedData} = rightTree.tree[rightTree.currentTab];
    const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    const [errors, setErrors] = useState({});
    const errorRef = useRef();

    const lengthHandler = (value) => {
        const data = cloneDeep(translatedData);
        eachDeep(data,(obj)=>{
            if(obj?.key === selectedNode?.key){
                obj.LENGTH = parseInt(value, 10).toString();
                return;
            }
        })
        const updatedData = getUpdatedData(data,templateHeader?.FILETYPE,parentScreen,rightTree.currentTab);
        const node  = getSelectedNodes([selectedNode?.key],updatedData)[0];
        props.setBegin(node?.BEGIN);
        props.setEnd(node?.END);

        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedData,
            })
        );

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceChangeHandler = useCallback(debounce(lengthHandler, 800), [
        rightTree.currentTab,
        rightTree.tree,
    ]);

    const handleLengthChange = (e) => {
        // Regular expression to match numbers only
        // const re = /^[0-9\b]+$/;
        const {name, value} = e.target;
        const errorState = validateOnFlow(name, value,{
          [name] : genericRules.numericRule
        })
    
        props.setLength(value);
        setErrors((prev) => ({
          ...prev,
          ...errorState
        }))
    
        if(isEmpty(errorState) || !value){
            debounceChangeHandler(e.target.value);
        }
    
        if(!isEmpty(errorState)){
          setTimeout(()=>{
            props.setLength((previousPrecisionValue) => {
              let val = previousPrecisionValue;
              val = val.replace(/\D/g, '');
              if(val.length > 9){
                val = val.substring(0,9);
              }
              return val;
            })
          },validateRevertTime)
        }
        
        if(errorRef.current){
          clearTimeout(errorRef.current);
        }
    
        errorRef.current = setTimeout(() => {
          setErrors((previousErrorState) => {
            const copyPrev = JSON.parse(JSON.stringify(previousErrorState));
            delete copyPrev[name];
            return copyPrev;
          })
        }, validationTime)
    
      };
    
    useEffect(()=>{
        if(timerID.current){
            clearTimeout(timerID.current);
        }
        timerID.current =setTimeout(()=>{
            eachDeep(translatedData,(obj)=>{
                if(obj?.key === selectedNode?.key){
                    props.setLength(isNaN(obj?.LENGTH) ? '0' : obj?.LENGTH || '');
                    props.setBegin(obj?.BEGIN || '');
                    props.setEnd(obj?.END || '');
                }   
            })
        },0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedNode.key])

    return (
        <>
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    label={t("LBL_LENGTH")}
                    type="text"
                    className={"width-100"}
                    name={"LENGTH"}
                    value={props.length}
                    onChange={(e) => {
                        handleLengthChange(e)
                    }}
                    onBlur={(e) => {
                        if (!e.target.value) {
                            props.setLength('0');
                            props.setEnd(Number(props.begin) - 1)
                        }
                    }}
                    helperText={errors?.LENGTH}
                    error={has(errors,"LENGTH")}
                />
            </FormControl>
                
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    label={t("LBL_BEG_POSITION")}
                    type="text"
                    className={"width-100"}
                    disabled
                    value={props.begin}
                    name={"BEGIN"}
                />
            </FormControl>

            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    label={t("LBL_END_POSITION")}
                    type="text"
                    className={"width-100"}
                    value={props.end}
                    disabled
                    name={"END"}
                />
            </FormControl>

        </>
    )
}

export default FixedLengthFieldProperty